import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { RouterModule } from '@angular/router';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StackedListComponent } from './stacked-list.component';
import { SharedUiThemingModule } from '@tcc-mono/shared/ui/theming';
import { TranslocoModule } from '@ngneat/transloco';
import { DisplayListIconPipe, DisplayPropPipe, DisplayAvatarPipe, DisplayColorPipe } from './stacked-list.util';

import {
  faChevronRight,
  faSquareCheck,
  faSquare,
} from '@fortawesome/pro-light-svg-icons';
import { SharedUtilsModule } from '@tcc-mono/shared/utils';
import { ScrollingModule } from '@angular/cdk/scrolling';

const icons: IconDefinition[] = [
  faChevronRight,
  faSquareCheck,
  faSquare,
]

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    SharedUiThemingModule,
    TranslocoLocaleModule,
    TranslocoModule,
    RouterModule,
    SharedUtilsModule,
    ScrollingModule
  ],
  declarations: [
    StackedListComponent,
    DisplayPropPipe,
    DisplayListIconPipe,
    DisplayAvatarPipe,
    DisplayColorPipe
  ],
  exports: [
    StackedListComponent
  ]
})
export class StackedListModule {
  private readonly _lib: FaIconLibrary = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(...icons);
  }
}
